import { v4 } from 'uuid';
import { useActiveProjectId, useService } from '../../../../../hooks';

import PatientService from '../../../../../services/PatientService';
import { useImpressionEditorContext } from './Context';
const patientService = new PatientService();

export const usePastedFile = (onFileUpload?: () => void) => {
  const { activeImpression, patient } = useImpressionEditorContext();

  const activeProjectId = useActiveProjectId();
  const [uploadPatientFile] = useService(patientService.uploadPatientFile);

  const uploadFile = async (
    file: File,
  ): Promise<fhir.Reference | undefined> => {
    const fileName = `${new Date().toISOString()}-${file.name}`;
    const fileId = v4();

    const res = await uploadPatientFile({
      id: fileId,
      file,
      subjectId: patient.id!,
      projectId: activeProjectId,
      name: fileName,
      contentType: file.type,
      documentReference: {
        type: {
          coding: [
            {
              system: 'http://lifeomic.com/fhir/document-type',
              code: 'clinician-upload-reference',
            },
          ],
          text: fileName,
        },
        meta: {
          tag: [
            {
              system: 'http://lifeomic.com/fhir/resource-visibility',
              code: 'clinic-only',
            },
            {
              system: 'http://lifeomic.com/fhir/document-type',
              code: 'clinician-upload-reference',
            },
            {
              system: 'http://lifeomic.com/fhir/source',
              code: 'clinician-upload',
            },
            {
              system: 'http://lifeomic.com/fhir/source-type',
              code: 'clinician-provided-member-file',
            },
          ],
        },
      },
    });
    const temporaryReference: fhir.Reference = {
      reference: `DocumentReference/${res.data.attributes.documentReference.id}`,
    };
    const reference = activeImpression!.addAttachment(temporaryReference);
    onFileUpload?.();
    return reference;
  };

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    return uploadFile(file);
  };

  const handlePastedFile = async (file: File) => {
    return uploadFile(file);
  };

  return { handleFileUpload, handlePastedFile };
};
